module.exports = __webpack_public_path__ + "img/acelerografica.99195f19.svg";